<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>

      <v-flex xs12>
        <v-card tile flat>
          <v-card-text>
            <h3 class="headline text-xs-center mx-2 my-2">{{ article.title }}</h3>
            <v-divider/>
            <p class="text-xs-center mt-1 mb-2">
              <span v-if="article.source" class="ml-2">文章来源：{{ article.source }}</span>
              <span v-if="article.author" class="ml-2">发布：{{ article.author }}</span>
              <span v-if="article.pubDate" class="ml-2">发布时间：{{ article.pubDate }}</span>
              <span v-if="article.visited" class="ml-2">点击数：{{ article.visited }}</span>
            </p>
            <div v-if="article.cover" class="px-4 py-2 x-article-cover">
              <img class="" :src="`/api/web/file/${article.cover}`"/>
            </div>
            <!-- 学术活动相关内容 -->
            <div style="width: auto;display: table;margin: 0 auto;">
              <p v-if="article.title && article.speaker">
                <span class="subheader">报告题目：</span>{{ article.title }}
              </p>
              <p v-if="article.speaker">
                <span class="subheader">报告人：</span>{{ article.speaker }}
              </p>
              <p v-if="article.dateTime">
                <span class="subheader">活动时间：</span>{{ article.dateTime.substring(0, 10) }}
                {{ article.dateTime.substring(11, 16) }}
              </p>
              <p v-if="article.venue">
                <span class="subheader">活动地点：</span>{{ article.venue }}
              </p>
              <p v-if="article.organizer">
                <span class="subheader">主办单位：</span> {{ article.organizer }}
              </p>
            </div>
            <v-content v-if="article.content" class="px-4 py-2 ck ck-editor__main">
              <div id="#x-article-wrapper" class="ck ck-content" v-html="article.content"></div>
            </v-content>
            <v-content v-else class="px-4 py-2">[正在建设中…]</v-content>

            <div v-if="article.attachments && article.attachments.length > 0">
              <p class="my-1">附件列表：</p>
              <v-divider/>
              <ol class="section-list">
                <li v-for="a in article.attachments" :key="a.dbid" class="pt-1 x-ellipsis">
                  <a :href="`/api/web/file/${a.dbid}`" target="_blank" v-on:click="onDownload(a, $event)">
                    {{ a.fileName }}
                    ({{ a.size | fileSize }})
                  </a>
                </li>
              </ol>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="diaAlert" persistent max-width="290">
      <v-card>
        <v-card-title class="subheading">提示！</v-card-title>
        <v-divider />
        <v-card-text>请登录后，再下载附件。</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary" depressed @click="diaAlert = false">关闭</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from "vuex";

export default {
  name: "Article",
  data() {
    return {
      article: {},
      diaAlert: false
    }
  },

  computed: {
    ...mapGetters([
      'userId',
      'authenticated',
      'name',
      'username',
      'passwordRaw',
      'deptId',
      'roleId',
      'deptName',
      'roleName',
      'deptRoles'
    ])
  },

  beforeRouteEnter(to, from, next) {
    const uri = `/api/site/article/${to.params.dbid}`;
    Vue.axios.get(uri).then(
      rsp => next(vm => vm.article = rsp.data)
    )
  },
  // 路由改变前，组件就已经渲染完了
  // 逻辑稍稍不同
  beforeRouteUpdate(to, from, next) {
    const uri = `/api/site/article/${to.params.dbid}`;
    const vm = this;
    Vue.axios.get(uri).then(
      rsp => {
        vm.article = rsp.data;
        next()
      }
    )
  },
  methods: {
    onDownload(it, ev) {
      window.console.log("in onDownload")
      if (this.article["attchReqLogin"] === 'T' && !this.userId) {
        this.diaAlert = true
        ev.preventDefault()
        ev.stopPropagation()
      }
    }
  }
}
</script>

<style>
.x-article-cover {
  margin: 0 auto;
  width: 100%;
  max-width: 600px;
}

.x-article-cover img {
  width: 100%;
}

#x-article-wrapper pre {
  white-space: pre
}

#x-article-wrapper button, textarea,
#x-article-wrapper input, select {
  display: inline-block
}

#x-article-wrapper big {
  font-size: 1.17em
}

#x-article-wrapper small, sub, sup {
  font-size: .83em
}

#x-article-wrapper sub {
  vertical-align: sub
}

#x-article-wrapper sup {
  vertical-align: super
}

#x-article-wrapper table {
  border-spacing: 2px;
}

#x-article-wrapper thead, tbody,
#x-article-wrapper tfoot {
  vertical-align: middle
}

#x-article-wrapper td, th, tr {
  vertical-align: inherit
}

#x-article-wrapper s, strike, del {
  text-decoration: line-through
}

#x-article-wrapper hr {
  border: 1px inset
}

#x-article-wrapper ol, ul, dir,
#x-article-wrapper menu, dd {
  margin-left: 40px
}

#x-article-wrapper ol {
  list-style-type: decimal
}

#x-article-wrapper ol ul, ul ol,
#x-article-wrapper ul ul, ol ol {
  margin-top: 0;
  margin-bottom: 0
}

#x-article-wrapper u, ins {
  text-decoration: underline
}

#x-article-wrapper br:before {
  content: "\A";
  white-space: pre-line
}

#x-article-wrapper center {
  text-align: center
}

#x-article-wrapper :link, :visited {
  text-decoration: underline
}

#x-article-wrapper :focus {
  outline: thin dotted invert
}

/* Begin bidirectionality settings (do not change) */
#x-article-wrapper BDO[DIR="ltr"] {
  direction: ltr;
  unicode-bidi: bidi-override
}

#x-article-wrapper BDO[DIR="rtl"] {
  direction: rtl;
  unicode-bidi: bidi-override
}

#x-article-wrapper *[DIR="ltr"] {
  direction: ltr;
  unicode-bidi: embed
}

#x-article-wrapper *[DIR="rtl"] {
  direction: rtl;
  unicode-bidi: embed
}

@media print {
  #x-article-wrapper h1 {
    page-break-before: always
  }

  #x-article-wrapper h1, h2, h3,
  #x-article-wrapper h4, h5, h6 {
    page-break-after: avoid
  }

  #x-article-wrapper ul, ol, dl {
    page-break-before: avoid
  }
}
</style>
